module.exports = __webpack_public_path__ + "static/media/map-scroll.1b7a834a.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/map-scroll.mov
// module id = 225
// module chunks = 0